import { getDefaultSubdomain } from "@app/redux/data/config";
import { getSubdomain, isValidAlias } from "@app/utils/helpers";
import { getMyInfo, logout } from "../../API";
import { resetApp } from "../../_Home/actions";
import { Profile, UserContext } from "../../types-business/Profile";
import IAction from "../../types/IAction";
import actionTypes, { LOGOUT } from "../actionTypes";
import { getLoginRedirectUrl } from "../components/Auth/utils";
import { getMyCompanyAlias, getMyCompanyId } from "../reducers/selectors";

const NOOP = () => {};

export const loadMyProfile = () => ({
  type: actionTypes.LOAD_MY_PROFILE,
  promise: getMyInfo(),
});

export const refreshMyProfile = () => ({
  type: actionTypes.REFRESH_MY_PROFILE,
  promise: getMyInfo(),
});

export const setUserContext = (
  userContext: UserContext | Profile
): IAction => ({
  type: actionTypes.SET_USER_CONTEXT,
  payload: userContext,
});

export const fetchLoginUrl = (forceAlias?: string) => (dispatch, getState) => {
  const alias = getSubdomain();
  const defaultSubdomain = getDefaultSubdomain(getState());
  const companyId = getMyCompanyId(getState());
  const companyAlias = getMyCompanyAlias(getState());
  let loginUrl = getLoginRedirectUrl({ alias: forceAlias });

  if (
    isValidAlias(alias, defaultSubdomain) &&
    !!companyId &&
    alias !== companyAlias
  ) {
    // The user will be redirected to the proper company hostname since the SSO logout will not work
    const href = window.location.href;
    window.location.href = href.replace(
      alias,
      companyAlias || defaultSubdomain
    );
  } else {
    dispatch(getLoginUrlAction(loginUrl));
  }
};

const getLoginUrlAction = (url) => ({
  type: actionTypes.FETCH_LOGIN_URL,
  payload: url,
});

export const logoutUser = (onSuccess = NOOP, onFailure = NOOP) => {
  return (dispatch) => {
    dispatch({
      type: LOGOUT,
      promise: logout(),
      meta: {
        onSuccess: () => {
          dispatch(setUserContext(null));
          dispatch(resetApp());
          onSuccess();
        },
        onFailure: () => {
          onFailure();
        },
      },
    });
  };
};
